export function buildElevioArticleLink({ languageId, baseUrl, slug, id, }) {
    if (!baseUrl)
        return null;
    const base = baseUrl.startsWith('http') ? baseUrl : `https://${baseUrl}`;
    return `${base}/${languageId}/articles/${id}-${slug}/`;
}
